import React, { ReactNode, useEffect, useRef, useState } from 'react';
import { AnyObject } from 'yup/lib/types';

import Dialog from '../../shared/PFDialog/PFDialogContainer';
import TimerGif from '../../../assets/images/sand-clock.gif';
import { clientDetails } from '../../../constants';

import { reAssignInstaller } from './service';

interface ICxSchedulerReassignDialogProps {
  projectId: number;
  projectNumber: string;
  executionId: number;
  visible: boolean;
  // eslint-disable-next-line no-unused-vars
  onHide: (val: boolean) => void;
  callFromBeta: boolean | number;
}
function CxSchedulerReassignDialog({
  projectId,
  projectNumber,
  executionId,
  visible,
  onHide,
  callFromBeta,
}: ICxSchedulerReassignDialogProps) {
  if (
    !projectId ||
    !projectNumber ||
    !executionId ||
    typeof visible !== 'boolean' ||
    typeof onHide !== 'function'
  ) {
    return <></>;
  }
  const loading = useRef<number>(1);
  const [, setLoadingValue] = useState<number>(1);
  const [errorMessage, setErrorMessage] = useState<string>('');
  const setLoading = (val: number) => {
    loading.current = val;
    setLoadingValue(val);
  };
  useEffect(() => {
    if (visible) {
      setLoading(1);
      setErrorMessage('Something went wrong');
      reAssignInstaller(projectId, executionId, callFromBeta)
        .then(() => {
          setLoading(2);
          setTimeout(() => onHide(false), 2000);
        })
        .catch(ex => {
          console.error('Error reassigning installer:', ex);
          setLoading(3);
          if (typeof ex === 'object' && ex !== null && 'status' in ex) {
            setErrorMessage(
              'response' in ex
                ? (ex as { response: AnyObject })?.response?.data?.message
                : 'Something went wrong'
            );
          } else {
            setErrorMessage('Something went wrong');
          }
        });
    } else {
      setLoading(0);
    }
  }, [visible]);
  const headerElement: ReactNode = (
    <div className="flex-column flex flex-wrap align-items-center justify-content-center">
      <span>Re-schedule</span>
      <span className="text-sm">Project Number: {projectNumber}</span>
    </div>
  );
  return (
    <Dialog
      id="slotBookCalendarDialog"
      visible={visible}
      onHide={() => onHide(false)}
      closable={[2, 3].includes(loading.current)}
      dismissableMask={[2, 3].includes(loading.current)}
      closeOnEscape={[2, 3].includes(loading.current)}
      header={headerElement}
      className="xs:w-full sm:w-10 md:w-6 lg:w-6"
      pt={{
        root: {
          className: `overflow-auto h-auto`,
        },
        content: {
          className: 'pt-1',
        },
      }}
    >
      <div className="flex-column justify-content-center align-items-center flex h-auto w-full text-center">
        {clientDetails?.logo ? (
          <img src={clientDetails?.logo} className="w-5rem" alt="Logo" />
        ) : (
          <div className="h-3rem w-3rem flex align-items-center justify-content-center border-circle bg-gray-300 text-white">
            <div className="text-uppercase text-xl font-bold">
              {(clientDetails?.client_name?.split(' ') || [])
                .map((name: string) => name.charAt(0))
                .join('')}
            </div>
          </div>
        )}
        {loading.current === 1 && (
          <>
            <span className="p-2 text-xl">
              Hold tight! We&apos;re working our scheduling magic to find the
              next best technician for your appointment. It won&apos;t take
              long, unless our scheduler decides to grab a coffee first! ☕
            </span>
            <img src={TimerGif} alt="" height={20} width={20} />
          </>
        )}
        {loading.current === 2 && (
          <div className="flex align-items-center justify-content-center flex-wrap">
            <span className="pi pi-check text-green-500 text-sm" />
            <span className="p-2 text-xl">
              Technician assigned successfully
            </span>
          </div>
        )}
        {loading.current === 3 && errorMessage && (
          <>
            <div className="flex align-items-center justify-content-center flex-wrap">
              <span className="pi pi-times text-red-500 text-sm" />
              <span className="p-2 text-xl text-red-500">{errorMessage}</span>
            </div>
          </>
        )}
      </div>
    </Dialog>
  );
}

export default CxSchedulerReassignDialog;
